import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import Select from "react-select";
import { Button, Card, CardBody, Col, FormFeedback, Input, Label, Row, Table } from "reactstrap";
import * as Yup from "yup";
import "./style.scss";

import ToastDialog from "components/Common/ToastDialog";

import { formatDateString, formatDateString1 } from "./borrowingProfile";
import { decryptedValue, isPermission } from "common/utility";
import { callGetProbeCreditRatings } from "http/fundLync/entityDocuments.helper";
import PropTypes from "prop-types";
import { addCamData, editCamData, getCamData } from "http/fundLync/cam.helper";

const TableRow = ({
  onDelete,
  index,
  validation,
  percentageholdingValue,
}) => {

  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`directorList.${index}.${field}`, value);
    if (field == "percentageHolding") {
      percentageholdingValue(+value);
    }
  };

  return (
    <tr>
      <td>
        <Input
          type="text"
          placeholder="Enter Director Name"
          name={`director[${index}].name`}
          id={`director[${index}].name`}
          value={validation.values.directorList[index].name}
          onChange={(event) => {
            handleInputChange(index, "name", event.target.value);
          }}
          invalid={
            validation.touched?.directorList?.[index]?.name &&
              validation.errors?.directorList?.[index]?.name
              ? true
              : false
          }
        />

        {validation.touched.directorList?.[index]?.name &&
          validation.errors.directorList?.[index]?.name && (
            <FormFeedback>
              {validation.errors.directorList?.[index]?.name}
            </FormFeedback>
          )}
      </td>
      <td style={{ width: "30%" }}>

        <Input
          type="text"
          placeholder="Enter designation"
          name={`director[${index}].designation`}
          id={`director[${index}].designation`}
          value={validation.values.directorList[index].designation}
          onChange={(event) => {
            handleInputChange(index, "designation", event.target.value);
          }}
          invalid={
            validation.touched?.directorList?.[index]?.designation &&
              validation.errors?.directorList?.[index]?.designation
              ? true
              : false
          }
        />

        {validation.touched.directorList?.[index]?.designation &&
          validation.errors.directorList?.[index]?.designation && (
            <FormFeedback>
              {validation.errors.directorList?.[index]?.designation}
            </FormFeedback>
          )}
      </td>
      <td>
        <Input
          type="text"
          placeholder="Enter Din"
          name={`director[${index}].din`}
          id={`director[${index}].din`}
          value={validation.values.directorList[index].din}
          onChange={(event) => {
            handleInputChange(index, "din", event.target.value);
          }}
        />
      </td>
      <td>
        {validation.values?.directorList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );
};
const TableRowShare = ({
  onDelete,
  index,
  validation,
  percentageholdingValue,
  noPercentageholdingValue,
}) => {
  const [shareholderType, setShareholderType] = useState([]);


  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`shareholderList.${index}.${field}`, value);
    if (field == "percentage_holding") {
      percentageholdingValue(+value);
    }
    if (field == "no_of_shares") {
      noPercentageholdingValue(+value);
    }
  };

  return (
    <tr>
      <td>
        <Input
          type="text"
          placeholder="Enter Shareholder Name"
          name={`shareholder[${index}].full_name`}
          id={`shareholder[${index}].full_name`}
          value={validation.values.shareholderList[index].full_name}
          onChange={(event) => {
            handleInputChange(index, "full_name", event.target.value);
          }}
          invalid={
            validation.touched?.shareholderList?.[index]?.full_name &&
              validation.errors?.shareholderList?.[index]?.full_name
              ? true
              : false
          }
        />
        {validation.touched.shareholderList?.[index]?.full_name &&
          validation.errors.shareholderList?.[index]?.full_name && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.full_name}
            </FormFeedback>
          )}
      </td>
      <td style={{ width: "30%" }}>
        <Input
          type="text"
          placeholder="Enter no of shares"
          name={`shareholder[${index}].no_of_shares`}
          id={`shareholder[${index}].no_of_shares`}
          value={validation.values.shareholderList[index].no_of_shares}
          onChange={(event) => {
            handleInputChange(index, "no_of_shares", event.target.value);
          }}
          invalid={
            validation.touched?.shareholderList?.[index]?.no_of_shares &&
              validation.errors?.shareholderList?.[index]?.no_of_shares
              ? true
              : false
          }
        />
        {validation.touched.shareholderList?.[index]?.no_of_shares &&
          validation.errors.shareholderList?.[index]?.no_of_shares && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.no_of_shares}
            </FormFeedback>
          )}
      </td>
      <td>
        <Input
          type="text"
          placeholder="Enter Shareholding Percentage"
          name={`shareholder[${index}].percentage_holding`}
          id={`shareholder[${index}].percentage_holding`}
          value={validation.values.shareholderList[index].percentage_holding}
          onChange={(event) => {
            handleInputChange(index, "percentage_holding", event.target.value);
          }}
          invalid={
            validation.touched?.shareholderList?.[index]?.percentage_holding &&
              validation.errors?.shareholderList?.[index]?.percentage_holding
              ? true
              : false
          }
        />

        {validation.touched.shareholderList?.[index]?.percentage_holding &&
          validation.errors.shareholderList?.[index]?.percentage_holding && (
            <FormFeedback>
              {validation.errors.shareholderList?.[index]?.percentage_holding}
            </FormFeedback>
          )}
      </td>
      <td>
        {validation.values?.shareholderList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );
};
const TableRowPublic = ({
  onDelete,
  index,
  validation,
  percentageholdingValue,
  noPercentageholdingValue
}) => {
  const [shareholderType, setShareholderType] = useState([]);

  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`publicShareholdings.${index}.${field}`, value);
    if (field == "percentage_holding") {
      percentageholdingValue(+value);
    }
    if (field == "no_of_shares") {
      noPercentageholdingValue(+value);
    }
  };

  return (
    <tr>
      <td>
        <Input
          type="text"
          placeholder="Enter Shareholder Name"
          name={`publicShareholdings[${index}].full_name`}
          id={`publicShareholdings[${index}].full_name`}
          value={validation.values.publicShareholdings[index].full_name}
          onChange={(event) => {
            handleInputChange(index, "full_name", event.target.value);
          }}
          invalid={
            validation.touched?.publicShareholdings?.[index]?.full_name &&
              validation.errors?.publicShareholdings?.[index]?.full_name
              ? true
              : false
          }
        />
        {validation.touched.publicShareholdings?.[index]?.full_name &&
          validation.errors.publicShareholdings?.[index]?.full_name && (
            <FormFeedback>
              {validation.errors.publicShareholdings?.[index]?.full_name}
            </FormFeedback>
          )}
      </td>
      <td style={{ width: "30%" }}>
        <Input
          type="text"
          placeholder="Enter no of shares"
          name={`publicShareholdings[${index}].no_of_shares`}
          id={`publicShareholdings[${index}].no_of_shares`}
          value={validation.values.publicShareholdings[index].no_of_shares}
          onChange={(event) => {
            handleInputChange(index, "no_of_shares", event.target.value);
          }}
          invalid={
            validation.touched?.publicShareholdings?.[index]?.no_of_shares &&
              validation.errors?.publicShareholdings?.[index]?.no_of_shares
              ? true
              : false
          }
        />
        {validation.touched.publicShareholdings?.[index]?.no_of_shares &&
          validation.errors.publicShareholdings?.[index]?.no_of_shares && (
            <FormFeedback>
              {validation.errors.publicShareholdings?.[index]?.no_of_shares}
            </FormFeedback>
          )}
      </td>
      <td>
        <Input
          type="text"
          placeholder="Enter Shareholding Percentage"
          name={`publicShareholdings[${index}].percentage_holding`}
          id={`publicShareholdings[${index}].percentage_holding`}
          value={validation.values.publicShareholdings[index].percentage_holding}
          onChange={(event) => {
            handleInputChange(index, "percentage_holding", event.target.value);
          }}
          invalid={
            validation.touched?.publicShareholdings?.[index]?.percentage_holding &&
              validation.errors?.publicShareholdings?.[index]?.percentage_holding
              ? true
              : false
          }
        />

        {validation.touched.publicShareholdings?.[index]?.percentage_holding &&
          validation.errors.publicShareholdings?.[index]?.percentage_holding && (
            <FormFeedback>
              {validation.errors.publicShareholdings?.[index]?.percentage_holding}
            </FormFeedback>
          )}
      </td>
      <td>
        {validation.values?.publicShareholdings?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </td>
    </tr>
  );
};
const CamDirectorList = forwardRef((props, ref) => {
  document.title = "Directors & Shareholders list | FundLync";
  const { queryString } = props; 
  const currentDate = new Date().toISOString().split("T")[0];

  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);


  const [directorRows, setDirectorRows] = useState([
    {
      name: "",
      designation: "",
      din: "",
    },
  ]);
  const [shareholdingRows, setShareholdingRows] = useState([
    {
      full_name: "",
      no_of_shares: "",
      percentage_holding: "",
    },
  ]);
  const [publicShareholdingRows, setPublicShareholdingRows] = useState([
    {
      full_name: "",
      no_of_shares: "",
      percentage_holding: "",
    },
  ]);
  const [shareholdingList, setShareholdingList] = useState([]);
  const [directorList, setDirectorList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [percentageholdingValue, setPercentageholdingValue] = useState(0);
  const [noPercentageholdingValue, setNoPercentageholdingValue] = useState(0);
  const [editMode, setEditMode] = useState(false)
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')
  const [totalnoShare, setTotalnoShare] = useState([])
  const [shareholdingsDate, setShareholdingsDate] = useState([]);
  const encodedDealId = urlParams.get("dealId");
  const dealId = atob(encodedDealId);
  const [camData, setCamData] = useState([])

  useEffect(() => {
    const userDetails = decryptedValue(localStorage.getItem("user"));
    if (userDetails.entityType === "Partner" || userDetails.entityType === "Owner") {
      setEncodedId(urlParams.get("id"))
      setEntityId(atob(encodedId))
    } else {
      setEncodedId(entityId)
      setEntityId(userDetails.entityId)
    }
  }, [entityId, encodedId])

  useEffect(() => {
    const loadData = async () => {
      try {
        // Fetch the CAM data
        const response = await getCamData({ dealId });
        setCamData([response?.data[0]]);
        const data = response?.data[0]
        if (response?.status && data?.directorSharehodlerList != null) {
          setShareholdingList(data?.directorSharehodlerList.shareholdingList);
          setDirectorList(data?.directorSharehodlerList.directorList);
          setDirectorRows(data?.directorSharehodlerList.directorList);
          setTotalnoShare(formatWithCommas(data?.directorSharehodlerList.totalShares));
          setShareholdingsDate(data?.directorSharehodlerList.shareholdingsDate);
          setShareholdingRows(data?.directorSharehodlerList.shareholdingList);
          setPublicShareholdingRows(data?.directorSharehodlerList.publicShareholdings)
        } else {
          const probeResponse = await callGetProbeCreditRatings({ entityId });

          if (probeResponse?.status && probeResponse?.data?.authorized_signatories?.length > 0 && probeResponse?.data?.isManual == false) {
            const allDirectors = probeResponse.data?.authorized_signatories || [];
            if (allDirectors.length > 0) {
              setDirectorList(allDirectors);
              setDirectorRows(allDirectors);
            }
            const allshareholdings = probeResponse.data?.director_shareholdings || [];
            const totalShares = probeResponse.data?.shareholdings_summary[0]?.total_equity_shares || [];
            const totalPromoterShares = allshareholdings.reduce((acc, curr) => acc + (curr.no_of_shares || 0), 0);
            const totalPromoterPercentage = allshareholdings.reduce((acc, curr) => acc + (curr.percentage_holding || 0), 0);

            const publicPercentage = 100 - totalPromoterPercentage;
            const publicShares = totalShares - totalPromoterShares;
            const shareHoldingDate = formatDateString1(allshareholdings?.[0]?.financial_year) || "";
            const filteredShareholdings = allshareholdings.filter(
              (shareholding) => shareholding.no_of_shares > 0 || shareholding.percentage_holding > 0
            );
            const publicShare = [{ full_name: "others", no_of_shares: publicShares, percentage_holding: publicPercentage }]

            if (filteredShareholdings.length > 0) {
              setShareholdingList(filteredShareholdings);
              setTotalnoShare(formatWithCommas(totalShares));
              setShareholdingsDate(shareHoldingDate)
              setShareholdingRows(filteredShareholdings);
              setPublicShareholdingRows(publicShare);
            }
          }
        }

      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    loadData();
  }, [entityId]);

  const toggleEditMode = () => {
    setEditMode(!editMode);
  }

  const handleDelete = (rowIndex) => {
    validation.values.directorList.splice(rowIndex, 1);
    // setPercentageholdingValue(0);
    // setNoPercentageholdingValue(0)
    validation.validateForm();
  };
  setNoPercentageholdingValue
  const formatWithCommas = (value) => {
    if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
      return Number(value).toLocaleString('en-IN');
    }
    return value;
  };
  const handleDeleteshareholder = (rowIndex) => {
    validation.values.shareholderList.splice(rowIndex, 1);
    setPercentageholdingValue(0);
    setNoPercentageholdingValue(0)
    validation.validateForm();
  };

  const handleDeletePublic = (rowIndex) => {
    validation.values.publicShareholdings.splice(rowIndex, 1);
    setPercentageholdingValue(0);
    setNoPercentageholdingValue(0);
    validation.validateForm();
  };

  const calculateTotalValue = (shareholderList, publicShareholdings) => {
    return [...shareholderList, ...publicShareholdings].reduce(
      (acc, { percentage_holding }) => acc + Number(percentage_holding || 0),
      0
    );
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      directorList: directorRows || [
        {
          name: "",
          designation: "",
          din: ""
        },
      ],
      shareholderList: shareholdingRows || [
        {
          full_name: "",
          no_of_shares: "",
          percentage_holding: ""
        },
      ],
      publicShareholdings: publicShareholdingRows || [
        {
          full_name: "",
          no_of_shares: "",
          percentage_holding: ""
        },
      ],
      shareHoldingDate: shareholdingsDate || "",
      totalShares: noPercentageholdingValue,
      totalPercentage: 0,

    },
    validationSchema: Yup.object({
      directorList: Yup.array().of(
        Yup.object({
          designation: Yup.string().required(
            "Designation is required"
          ).nullable(),
          name: Yup.string().required(
            "Director name is required"
          ).nullable(),
          // din: Yup.string().required(
          //   "Din is required"
          // ).nullable(),
        }),
      ),
      shareholderList: Yup.array().of(
        Yup.object({
          no_of_shares: Yup.string().required(
            "No of shares is required"
          ).nullable(),
          full_name: Yup.string().required(
            "Full Name is required"
          ).nullable(),
          percentage_holding: Yup.string().required(
            "Percentage holding is required"
          ).nullable(),
        }),
      ),
      publicShareholdings: Yup.array().of(
        Yup.object({
          no_of_shares: Yup.string().required(
            "No of shares is required"
          ).nullable(),
          full_name: Yup.string().required(
            "Full Name is required"
          ).nullable(),
          percentage_holding: Yup.string().required(
            "Percentage holding is required"
          ).nullable(),
        }),
      ),
      totalPercentage: Yup.number()
        .required("Total percentage is required")
        .test(
          "is-100-percent",
          "Total %Holding must equal 100%",
          function (_, context) {
            const { shareholderList, publicShareholdings } = context.parent;
            const totalValue = calculateTotalValue(
              shareholderList || [],
              publicShareholdings || []
            );
            return totalValue === 100;
          }
        ),
    }),
    onSubmit: (values) => {
      if (camData.length > 0) {
        let totalNoShares = 0;

        for (let value of validation.values.shareholderList) {
          totalNoShares += +value.no_of_shares;
        }
        for (let value of validation.values.publicShareholdings) {
          totalNoShares += +value.no_of_shares;
        }
        totalNoShares = Math.round(totalNoShares * 100) / 100;
        const entity = {
          aboutSection: camData[0]?.aboutSection,
          directorSharehodlerList: {
            directorList: values.directorList,
            publicShareholdings: values.publicShareholdings,
            shareholdingList: values.shareholderList,
            totalShares: totalNoShares,
            shareholdingsDate: values.shareHoldingDate,
            totalPercentage: calculateTotalValue(
              validation.values.shareholderList,
              validation.values.publicShareholdings
            ),
          },
          keyStrength: camData[0]?.keyStrength,
          finSummary: camData[0]?.finSummary,
          debtProfile: camData[0]?.debtProfile,
          customerSupplier: camData[0]?.customerSupplier,
          termsheet: camData[0]?.termsheet,
          entityId: entityId,
          dealId: dealId,
          id: camData[0]?.id,
          lastVisitedStep: "key-strengths" || null,
        }
        editCamData(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Cam Data Updated",
                showToast: true,
                role: "success",
              });
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        const entity = {
          aboutSection: camData[0]?.aboutSection,
          directorSharehodlerList: {
            directorList: values.directorList,
            publicShareholdings: values.publicShareholdings,
            shareholdingList: values.shareholderList,
            totalShares: totalNoShares,
            shareholdingsDate: values.shareHoldingDate,
            totalPercentage: calculateTotalValue(
              validation.values.shareholderList,
              validation.values.publicShareholdings
            ),
          },
          keyStrength: camData[0]?.keyStrength,
          finSummary: camData[0]?.finSummary,
          debtProfile: camData[0]?.debtProfile,
          customerSupplier: camData[0]?.customerSupplier,
          termsheet: camData[0]?.termsheet,
          entityId: entityId,
          dealId: dealId,
          id: camData[0]?.id,
          lastVisitedStep: 'key-strengths' || null,
        };
        addCamData(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Cam Data Saved",
                showToast: true,
                role: "success",
              });
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  });

  const onChangePercentageValue = (value) => {
    setPercentageholdingValue(percentageholdingValue + value);
  };

  const onChangenoOfPercentageValue = (value) => {
    setPercentageholdingValue(noPercentageholdingValue + value);
  };



  let totalNoShares = 0;

  for (let value of validation.values.shareholderList) {
    totalNoShares += +value.no_of_shares;
  }
  for (let value of validation.values.publicShareholdings) {
    totalNoShares += +value.no_of_shares;
  }
  totalNoShares = Math.round(totalNoShares * 100) / 100;
  useImperativeHandle(ref, () => ({
    handleSubmit: () => validation.handleSubmit(),
    getValidationStatus: () =>
      validation.validateForm().then((errors) => Object.keys(errors).length === 0),
  }));
  const totalValue = calculateTotalValue(
    validation.values.shareholderList,
    validation.values.publicShareholdings
  );
  return (

    <React.Fragment>
      <div>
        <h5 style={{ color: "#42B763" }}>List of Directors</h5>
      </div>
      <FormikProvider value={validation}>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <Row>
            <Col sm="12">
              <div className="table-responsive react-table">
                <Table
                  Table
                  striped
                  bordered
                  hover
                  style={{ width: "100%", backgroundColor: "white" }}
                >
                  <thead>
                    <tr>
                      <th>Director Name *</th>
                      <th>Designation *</th>
                      <th>Din </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <FieldArray
                      name="directorList"
                      render={(arrayHelpers) => (
                        <>
                          {validation.values.directorList.map(
                            (shareholder, index) => (
                              <TableRow
                                key={shareholder.id}
                                onDelete={handleDelete}
                                index={index}
                                validation={validation}
                              // percentageholdingValue={
                              //   onChangePercentageValue
                              // }
                              />
                            )
                          )}
                          <tr>
                            <td colSpan={5}>
                              <span
                                className="text-success"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  arrayHelpers.push({
                                    name: "",
                                    designation: "",
                                    din: "",
                                  });
                                }}
                              >
                                <i className="mdi mdi-plus me-1" /> Add Director
                              </span>
                            </td>
                          </tr>
                        </>
                      )}
                    />
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Form>
      </FormikProvider>

      <div>
        <h5 style={{ color: "#42B763" }}>Shareholding Pattern</h5>
      </div>
      <div className="shareholdingDiv">
        <i className="fas fa-exclamation-circle draft"></i> Total shareholding should add up to 100%
      </div>
      <FormikProvider value={validation}>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();

            return false;
          }}
        >
          <Row className="mt-4 mb-4">
            <Col lg={4} sm={12} className="me-5">
              <Label
                htmlFor="horizontal-email-Input"
                className="col-sm-12 col-form-label"
              >
                Shareholding as of *
              </Label>
              <Input
                type="date"
                className="form-control"
                name="shareHoldingDate"
                id="shareHoldingDate"
                max={currentDate}
                value={validation.values.shareHoldingDate || ""}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  !!(
                    validation.touched.shareHoldingDate &&
                    validation.errors.shareHoldingDate
                  )
                }
              />
              {validation.touched.shareHoldingDate &&
                validation.errors.shareHoldingDate ? (
                <FormFeedback type="invalid">
                  {validation.errors.shareHoldingDate}
                </FormFeedback>
              ) : null}
            </Col>
            <Col lg={3} sm={12}>
              <Label
                htmlFor="horizontal-email-Input"
                className="col-sm-12 mt-2"
              >
                Total No of Shares
              </Label>
              <div className="shareholdingPercent1">{formatWithCommas(totalNoShares)}</div>
            </Col>
            <Col lg={4} sm={12}>
              <Label
                htmlFor="horizontal-email-Input"
                className="col-sm-12 mt-2"
              >
                Total shareholding %
              </Label>
              <div className="shareholdingPercent"
              >{totalValue}

              </div>{validation.touched.totalPercentage && validation.errors.totalPercentage ? (
                <div className="error-message" style={{ color: "red", marginTop: "5px", fontSize: "11px", }}> {validation.errors.totalPercentage}
                </div>
              ) : null}
            </Col>

          </Row>
          <Row>
            <Col sm="12">
              <div className="table-responsive react-table">
                <Table
                  Table
                  striped
                  bordered
                  hover
                  style={{ width: "100%", backgroundColor: "white" }}
                >
                  <thead>
                    <tr>
                      <th>Shareholder Name *</th>
                      <th>No of Shares *</th>
                      <th>Shareholding % </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <FieldArray
                      name="shareholderList"
                      render={(arrayHelpers) => (
                        <>
                          {validation.values.shareholderList.map(
                            (shareholder, index) => (
                              <TableRowShare
                                key={shareholder.id}
                                onDelete={handleDeleteshareholder}
                                index={index}
                                validation={validation}
                                percentageholdingValue={
                                  onChangePercentageValue
                                }
                                noPercentageholdingValue={
                                  onChangenoOfPercentageValue
                                }
                              />
                            )
                          )}
                          <tr>
                            <td colSpan={5}>
                              <span
                                className="text-success"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  arrayHelpers.push({
                                    full_name: "",
                                    no_of_shares: "",
                                    percentage_holding: "",
                                  });
                                }}
                              >
                                <i className="mdi mdi-plus me-1" /> Add promotor
                                Shareholder
                              </span>
                            </td>
                          </tr>
                        </>
                      )}
                    />
                    <FieldArray
                      name="publicShareholdings"
                      render={(arrayHelpers) => (
                        <>
                          {validation.values.publicShareholdings.map(
                            (shareholder, index) => (
                              <TableRowPublic
                                key={shareholder.id}
                                onDelete={handleDeletePublic}
                                index={index}
                                validation={validation}
                                percentageholdingValue={
                                  onChangePercentageValue
                                }

                                noPercentageholdingValue={
                                  onChangenoOfPercentageValue
                                }
                              />
                            )
                          )}
                          <tr>
                            <td colSpan={5}>
                              <span
                                className="text-success"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  arrayHelpers.push({
                                    full_name: "",
                                    no_of_shares: "",
                                    percentage_holding: "",
                                  });
                                }}
                              >
                                <i className="mdi mdi-plus me-1" /> Add public
                                Shareholder
                              </span>
                            </td>
                          </tr>
                        </>
                      )}
                    />
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Form>
      </FormikProvider>
      <ToastDialog message={toastInfo.message} showToast={toastInfo.showToast} role={toastInfo.role} onCloseFn={() => setToastInfo({ showToast: false })} />
    </React.Fragment>
  );
});
CamDirectorList.propTypes = {
  history: PropTypes.object,
};

CamDirectorList.displayName = "DirectorList"
export default CamDirectorList;


